import {
  playerAtom,
  selectPlayerCurrentPlayRequest,
  selectPlayerIsAutoStopped,
} from "@sunrise/player";
import { atom } from "jotai";

import { playerManagerAtom } from "./player-manager.atom";

export const shouldPlayerAutostartAtom = atom((get) => {
  return (
    get(playerAtom).state === "idle" &&
    !get(selectPlayerCurrentPlayRequest) &&
    !get(playerManagerAtom).playRequest &&
    !get(selectPlayerIsAutoStopped)
  );
});
